module.exports = function() {
  return new Worker(__webpack_public_path__ + "73247abb2ba419c4f075.worker.js");
};